<template>
  <div class="profile-settings">
    <!-- ========================================== BEGINING CUSTOMER SECTION =================================================== -->
    <div class="profile-settings__actions">
      <span class="profile-settings__title">
        {{ $t(`common.myAccount.settings.customerSettingLabel`) }}</span
      >
      <div class="profile-settings__buttons">
        <nb-button simple color="secondary">cancel</nb-button>
        <nb-button color="error" v-on:click="saveCustomer()">save</nb-button>
      </div>
    </div>
    <nb-card class="card-settings">
      <div class="profile-settings__form">
        <nb-form
          :model="formCustomerSettings"
          :label-position="labelPosition"
          label-width="100%"
          class="profile-settings__form__name"
        >
          <nb-form-item id="customerName" label="Customer name">
            {{ formCustomerSettings.name }}
          </nb-form-item>
          <!-- TEMPORALLY REMOVED FROM 20.1.0.12 nb-form-item id="fleetCount" label="Fleet count">
            <nb-input
              v-model="formCustomerSettings.fleetCount"
              placeholder="Fleet count"
            ></nb-input>
          </nb-form-item-->
          <nb-form-item id="regions" label="Regions">
            <nb-checkbox
              v-for="(region, index) in regionsRefDataList"
              :key="index"
              :value="checkboxStatesList[index]"
              :label="regionsRefDataList[index]"
              :name="regionsRefDataList[index]"
              :checked="checkboxStatesList[index]"
              v-on:change="changeCheckboxState(index)"
              >{{ region }}</nb-checkbox
            >
          </nb-form-item>
        </nb-form>
      </div>
    </nb-card>
    <!-- ========================================== END CUSTOMER SECTION =================================================== -->
    <!-- ========================================== BEGINING PROFILE SECTION =================================================== -->
    <div class="profile-settings__actions">
      <span class="profile-settings__title">Profile settings</span>
      <div class="profile-settings__buttons">
        <nb-button simple color="secondary">cancel</nb-button>
        <nb-button color="error" v-on:click="saveProfile()">save</nb-button>
      </div>
    </div>
    <nb-card class="card-settings">
      <div>
        <nb-avatar
          :username="getCompiledUsername"
          :size="96"
          background-color="assistant"
        ></nb-avatar>
      </div>
      <div class="profile-settings__form">
        <nb-form
          :inline="true"
          :model="formInline"
          :label-position="labelPosition"
          label-width="100%"
          class="profile-settings__form__name"
        >
          <nb-form-item id="firstName" label="First name">
            <nb-input
              v-model="formInline.firstname"
              placeholder="First name"
            ></nb-input>
          </nb-form-item>
          <nb-form-item id="lastName" label="Name">
            <nb-input
              v-model="formInline.lastname"
              placeholder="Name"
            ></nb-input>
          </nb-form-item>
        </nb-form>
        <nb-form
          :inline="false"
          :model="formInline"
          :label-position="labelPosition"
          label-width="100%"
        >
          <nb-form-item
            id="email"
            label="Email"
            class="profile-settings__form__email"
          >
            <nb-input
              v-model="formInline.email"
              placeholder="Email"
              readonly="true"
            >
            </nb-input>
          </nb-form-item>
        </nb-form>
      </div>
    </nb-card>
    <!-- ========================================== END PROFIL SECTION =================================================== -->
    <!-- ========================================== BEGINING CONTRACT CUSTOMER INFORMATION =================================================== -->
    <!-- TEMPORALLY REMOVED FROM 20.1.0.12
    <div class="profile-settings__actions">
      <span class="profile-settings__title">Contract Information</span>
    </div>
    <nb-card class="card-settings">
      <div class="profile-settings__form">
        <nb-form
          :model="formCustomerSettings"
          :label-position="labelPosition"
          label-width="100%"
          class="profile-settings__form__contract"
        >
          <nb-form-item label="Account Manager">
            {{ formCustomerSettings.accountManager }}
          </nb-form-item>
          <nb-form-item label="Contract ID">
            {{ formCustomerSettings.contractID }}
          </nb-form-item>
          <nb-form-item label="Contract type">
            {{ formCustomerSettings.contractType }}
          </nb-form-item>
          <nb-form-item label="Contract Status">
            {{ formCustomerSettings.contractStatus }}
          </nb-form-item>
          <nb-form-item label="Contract Start">
            {{ formCustomerSettings.contractStart }}
          </nb-form-item>
          <nb-form-item label="Contract End">
            {{ formCustomerSettings.contractEnd }}
          </nb-form-item>
          <nb-form-item label="Delivery Cycle Start">
            {{ formCustomerSettings.deliveryCycleStart }}
          </nb-form-item>
          <nb-form-item label="Delivery Cycle End">
            {{ formCustomerSettings.deliveryCycleEnd }}
          </nb-form-item>
        </nb-form>
      </div>
    </nb-card>
    -->
    <!-- ========================================== END CCONTRACT CUSTOMER INFORMATION =================================================== -->
    <!-- ========================================== BEGINING PASSWORD SECTION =================================================== -->
    <div class="change-password__actions">
      <span class="change-password__title">Change password</span>
      <div class="change-password__buttons">
        <nb-button simple color="secondary">cancel</nb-button>
        <nb-button
          id="btnChangePassword"
          color="error"
          @click="savePassword('formPasswordSettings')"
          >change</nb-button
        >
      </div>
    </div>
    <nb-card class="card-password">
      <nb-form
        v-on:submit="$emit('submit')"
        ref="formPasswordSettings"
        :label-position="labelPosition"
        label-width="33%"
        :model="formPasswordSettings"
        :rules="formPasswordSettingsRules"
      >
        <nb-form-item
          prop="oldPassword"
          label="Old password"
          id="oldPasswordFormItem"
        >
          <nb-input
            id="oldPassword"
            v-model="formPasswordSettings.oldPassword"
            class="password-input"
            :type="showOldPassword ? 'text' : 'password'"
            icon="view"
            @icon-click="toggleShowOldPassword"
            auto-complete="off"
          />
        </nb-form-item>
        <nb-form-item
          prop="newPassword"
          label="New password"
          id="newPasswordFormItem"
        >
          <nb-tooltip
            class="nb-tooltip"
            placement="bottom"
            v-model="isOpenedTooltip"
            manual
          >
            <div slot="content">
              Password must contain at least : <br />-8 characters <br />
              -mixture of upper and lower case <br />-1 digit <br />-1 special
              character
            </div>
            <nb-input
              id="newPassword"
              v-model="formPasswordSettings.newPassword"
              :type="showNewPassword ? 'text' : 'password'"
              icon="view"
              @icon-click="toggleShowNewPassword"
              auto-complete="off"
              show-succes-icon
            ></nb-input>
          </nb-tooltip>
          <nb-button
            @click="isOpenedTooltip = !isOpenedTooltip"
            icon="help"
            circle
          />
        </nb-form-item>
        <nb-form-item
          prop="confirmationPassword"
          label="Confirm new password"
          id="confirmPasswordFormItem"
        >
          <nb-input
            id="confirmationPassword"
            v-model="formPasswordSettings.confirmationPassword"
            :type="showConfirmationPassword ? 'text' : 'password'"
            icon="view"
            @icon-click="toggleShowConfirmationPassword"
            auto-complete="off"
            show-succes-icon
          ></nb-input>
        </nb-form-item>
      </nb-form>
    </nb-card>
    <!-- ========================================== END PASSWORD SECTION =================================================== -->
    <div class="profile-settings__actions">
      <span class="profile-settings__title">Declared Database</span>
    </div>
    <div class="databases-content">
      <nb-table
        id="declaredDatabaseListTable"
        :data="declaredDatabaseList"
        :border="true"
        :stripe="true"
        :responsive="true"
      >
        <nb-table-column
          prop="c_navdbType"
          width="200"
          label="Database Type"
          sortable
        ></nb-table-column>
        <nb-table-column
          prop="c_databaseIndicator"
          width="200"
          label="Database Identifier"
          sortable
        ></nb-table-column>
        <nb-table-column width="200" label="Fleet Count" sortable>
          <template slot-scope="scope">
            <nb-input v-model="scope.row.c_fleetCount"></nb-input>
          </template>
        </nb-table-column>
        <nb-table-column
          label="Send Modification Request for Approval"
          width="200"
          align="center"
        >
          <template slot-scope="scope">
            <nb-button
              @click="
                sendPendingFleetCountRequestToJoget(
                  declaredDatabaseList,
                  scope.row
                )
              "
              type="text"
              name="saveFleetCountButton"
              >Send Request</nb-button
            >
          </template>
        </nb-table-column>
      </nb-table>
    </div>
    <!-- ========================================== END Decalred Database SECTION =================================================== -->
  </div>
</template>
<script>
import Vue from "vue";
import Component from "vue-class-component";
import router from "@/router/router";
import { storeData, fetchList, changePassword } from "../API/APIFunctions.js";
import store from "@/store/store";
import { mapGetters, mapActions, mapMutations } from "vuex";
import {
  Card as NbCard,
  Form as NbForm,
  Input as NbInput,
  Checkbox as NbCheckbox,
  Button as NbButton,
  FormItem as NbFormItem
} from "@navblue/navblue-ui";

@Component({
  components: { NbCard, NbForm, NbInput, NbCheckbox, NbButton, NbFormItem },
  computed: {
    ...mapGetters([
      "getCurrentUser",
      "getCurrentCustomer",
      "getCompiledUsername"
    ])
  },
  methods: {
    ...mapActions({
      getContactAndCustomerData: "getContactAndCustomerData"
    }),
    ...mapMutations([
      "setUserFirstName",
      "setUserLastName",
      "setUserUsername",
      "setUserPassword",
      "setUserIsFirstConnexion",
      "setCustomerRegions",
      "setCustomerAccountManager",
      "setCustomerContractID",
      "setCustomerContractType",
      "setCustomerContractStatus",
      "setCustomerContractStart",
      "setCustomerContractEnd",
      "setCustomerDeliveryCycleStart",
      "setCustomerDeliveryCycleEnd"
    ])
  }
})
export default class Admin extends Vue {
  data() {
    return {
      isOpenedTooltip: false,
      showOldPassword: false,
      showNewPassword: false,
      showConfirmationPassword: false,
      collapsed: true,
      items: [
        { name: "Redirect to menu", icon: "dashboard", path: "menu" },
        { name: "Redirect to navbar", icon: "browse", path: "navbar" },
        { name: "Redirect to icon", icon: "comment", path: "icon" }
      ],

      labelPosition: "top",
      formPasswordSettings: {
        oldPassword: "",
        newPassword: "",
        confirmationPassword: ""
      },
      formPasswordSettingsRules: {
        oldPassword: [
          {
            validator: this.validateOldPassword,
            required: true,
            trigger: "change"
          }
        ],
        newPassword: [
          {
            validator: this.validateNewPassword,
            required: true,
            trigger: "change"
          }
        ],
        confirmationPassword: [
          {
            validator: this.validateConfirmationPassword,
            required: true,
            trigger: "change"
          }
        ]
      },

      formInline: {
        firstname: "",
        lastname: "",
        email: ""
      },

      formCustomerSettings: {
        name: "",
        regions: [],
        accountManager: "",
        contractID: "",
        contractType: "",
        contractStatus: "",
        contractStart: "",
        contractEnd: "",
        deliveryCycleStart: "",
        deliveryCycleEnd: ""
      },

      regionsRefDataList: [],
      checkboxStatesList: [],
      declaredDatabaseList: []
    };
  }

  created() {
    var localThis = this;
    this.initialiseRegionsList()
      .then(function() {
        localThis.updateLocalData();
        return localThis.getContactAndCustomerData(
          localThis.getCurrentUser.username
        );
      })
      .then(function() {
        localThis.updateLocalData();
      });
    this.declaredDatabaseData();
  }

  async initialiseRegionsList() {
    var localThis = this;
    return fetchList(
      process.env.VUE_APP_BULLETIN_APP_ID,
      "" + process.env.VUE_APP_POSSIBLE_REGION_LIST
    )
      .then(json => {
        var data = json.data;
        for (var i = 0; i < data.length; i++) {
          localThis.regionsRefDataList.push(data[i].c_continent);
        }
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  }

  async declaredDatabaseData() {
    var localThis = this;
    return fetchList(
      process.env.VUE_APP_DATABASES_APP_ID,
      "" + process.env.VUE_APP_DECLARED_DATABASES_LIST,
      process.env.VUE_APP_JOGET_DDT_FILTER_FOR_DECLARED_DB_NAME +
        "=" +
        localThis.getCurrentCustomer.name
    )
      .then(json => {
        var data = json.data;
        data.forEach(element => {
          //Add element to the list
          element.oldFleetCount = element.c_fleetCount;
          localThis.declaredDatabaseList.push(element);
        });
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
      });
  }

  updateLocalData() {
    //Set local data
    var user = this.getCurrentUser;
    this.formInline.firstname = user.firstName;
    this.formInline.lastname = user.lastName;
    this.formInline.email = user.username;

    var customer = this.getCurrentCustomer;
    this.formCustomerSettings.name = customer.name;
    this.formCustomerSettings.regions = customer.regions;
    this.formCustomerSettings.accountManager = customer.accountManager;
    this.formCustomerSettings.contractID = customer.contractID;
    this.formCustomerSettings.contractType = customer.contractType;
    this.formCustomerSettings.contractStatus = customer.contractStatus;
    this.formCustomerSettings.contractStart = customer.contractStart;
    this.formCustomerSettings.contractEnd = customer.contractEnd;
    this.formCustomerSettings.deliveryCycleStart = customer.deliveryCycleStart;
    this.formCustomerSettings.deliveryCycleEnd = customer.deliveryCycleEnd;

    //Update Checked regions according to existing regions, and the region the customer suscribed to
    this.checkboxStatesList = [];
    this.regionsRefDataList.forEach(element => {
      if (this.formCustomerSettings.regions.indexOf(element) != -1) {
        this.checkboxStatesList.push(true);
      } else {
        this.checkboxStatesList.push(false);
      }
    });
  }
  toggleShowOldPassword() {
    this.showOldPassword = !this.showOldPassword;
  }
  toggleShowNewPassword() {
    this.showNewPassword = !this.showNewPassword;
  }
  toggleShowConfirmationPassword() {
    this.showConfirmationPassword = !this.showConfirmationPassword;
  }
  mounted() {
    //Warn the user to amend customer regions and set first connexion to false
    if (this.getCurrentUser.isFirstConnexion) {
      this.$Notify({
        title:
          "Hello, you are reminded to amend your bulletin area selection in your profile",
        message: "",
        type: "warning",
        duration: 0
      });
      //Set first connexion to false
      var localThis = this;
      var data = [{ id: "isFirstConnexion", value: "false" }];
      storeData(
        process.env.VUE_APP_BULLETIN_APP_ID,
        "" + process.env.VUE_APP_CONTACT_FORM,
        localThis.getCurrentUser.id,
        data
      )
        .then(response => {
          if (response.ok) {
            //Updating local data if the request is succesfull
            localThis.setUserIsFirstConnexion("false");
          } else {
            // eslint-disable-next-line no-console
            console.log("Error while storing first connexion flog to false");
          }
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.error(error);
        });
    }
  }

  changeCheckboxState(index) {
    Vue.set(this.checkboxStatesList, index, !this.checkboxStatesList[index]);
  }

  saveProfile() {
    var localThis = this;
    var data = [
      { id: "email", value: this.formInline.email },
      { id: "lastName", value: this.formInline.lastname },
      { id: "firstName", value: this.formInline.firstname }
    ];
    storeData(
      process.env.VUE_APP_BULLETIN_APP_ID,
      "" + process.env.VUE_APP_CONTACT_FORM,
      localThis.getCurrentUser.id,
      data
    )
      .then(response => {
        if (response.ok) {
          //Updating local data if the request is succesfull
          localThis.setUserFirstName(localThis.formInline.firstname);
          localThis.setUserUsername(localThis.formInline.email);
          localThis.setUserLastName(localThis.formInline.lastname);
          alert("Profile has been saved successfully");
        } else {
          // eslint-disable-next-line no-console
          console.log("Error while storing user data");
        }
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
        // eslint-disable-next-line no-console
        console.log("Error while saving informations about current profile");
      });
  }

  validateConfirmationPassword(rule, value, callback) {
    if (value != this.formPasswordSettings.newPassword || value === "") {
      callback(
        new Error("Confirmation password does not match the new password")
      );
    } else {
      callback();
    }
  }

  validateOldPassword(rule, value, callback) {
    if (value === "") {
      callback(new Error("Old passord cannot be empty"));
    } else {
      callback();
    }
  }

  validateNewPassword(rule, value, callback) {
    var regexLowerandUpperCase = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])" //Must contain at least : 1 lowercase and uppercase character + 1 numeric + 1 special character escape reserved Regex characters avoid conflicts
    );
    var regexDigit = new RegExp(
      "^(?=.*[0-9])" //Must contain at least : 1 lowercase and uppercase character + 1 numeric + 1 special character escape reserved Regex characters avoid conflicts
    );
    var regexSpecialCharacters = new RegExp(
      "^(?=.*[!@#&(){}?/*$^+=-])" //Must contain at least : 1 lowercase and uppercase character + 1 numeric + 1 special character escape reserved Regex characters avoid conflicts
    );
    var regexForbiddenValues = new RegExp(
      "^(?=.*[<>])" //The password must not contain the following characters : > or <
    );
    if (value.length < 7) {
      callback(new Error("Your password must contain at least 8 characters"));
    } else if (!regexLowerandUpperCase.test(value)) {
      callback(
        "Your password must contains a mixture of both uppercase and lowercase letters"
      );
    } else if (!regexDigit.test(value)) {
      callback("Your password must contains at least 1 digit");
    } else if (regexForbiddenValues.test(value)) {
      callback("Following values are forbidden : < >");
    } else if (!regexSpecialCharacters.test(value)) {
      callback(
        new Error(
          "Your password must contains special characters [!@#&()–{}?/*$^+=]"
        )
      );
    } else {
      callback();
    }
  }

  savePassword(formName) {
    this.$refs[formName].validate(valid => {
      if (valid) {
        document.getElementById("btnChangePassword").disabled = true;
        this.sendChangePassword().then(response => {
          this.$Notify({
            title: response.message,
            message: "",
            type: "info",
            duration: 3000
          });
          document.getElementById("btnChangePassword").disabled = false;
        });
      }
    });
  }

  async sendChangePassword() {
    try {
      return await changePassword(
        this.formInline.email,
        this.formPasswordSettings.oldPassword,
        this.formPasswordSettings.newPassword
      );
    } catch (err) {
      throw err;
    }
    // if (
    //   this.formInline.email === null ||
    //   this.formPasswordSettings.oldPassword === null ||
    //   this.formPasswordSettings.newPassword === null
    // )
    //   return false;
    // else {
    //   return changePassword(
    //     this.formInline.email,
    //     this.formPasswordSettings.oldPassword,
    //     this.formPasswordSettings.newPassword
    //   );
    // }
  }

  saveCustomer() {
    var localThis = this;
    var i = 0;
    //Initialize current local data about region
    this.formCustomerSettings.regions = [];
    //Building new regions string for joget database, and updating local regions
    var newRegions = "";
    for (i = 0; i < this.checkboxStatesList.length; i++) {
      if (this.checkboxStatesList[i]) {
        if (newRegions != "") {
          newRegions = newRegions + ";";
        }
        newRegions = newRegions + this.regionsRefDataList[i];
        //Amending local data
        this.formCustomerSettings.regions.push(this.regionsRefDataList[i]);
      }
    }
    //Making storing request
    var data = [
      { id: "regions", value: newRegions },
      { id: "accountManager", value: this.formCustomerSettings.accountManager },
      { id: "contractID", value: this.formCustomerSettings.contractID },
      { id: "contractType", value: this.formCustomerSettings.contractType },
      { id: "contractStatus", value: this.formCustomerSettings.contractStatus },
      { id: "contractStart", value: this.formCustomerSettings.contractStart },
      { id: "contractEnd", value: this.formCustomerSettings.contractEnd },
      {
        id: "deliveryCycleStart",
        value: this.formCustomerSettings.deliveryCycleStart
      },
      {
        id: "deliveryCycleEnd",
        value: this.formCustomerSettings.deliveryCycleEnd
      }
    ];
    storeData(
      process.env.VUE_APP_BULLETIN_APP_ID,
      "" + process.env.VUE_APP_CUSTOMER_FORM,
      localThis.getCurrentCustomer.id,
      data
    )
      .then(response => {
        if (response.ok) {
          localThis.updateStoredCustomerData();
          alert("Bulletin settings saved successfully");
        } else {
          // eslint-disable-next-line no-console
          console.log("Error while storing customer data");
        }
      })
      .catch(error => {
        // eslint-disable-next-line no-console
        console.error(error);
        // eslint-disable-next-line no-console
        console.log("Error while saving informations about current profile");
      });
  }

  /**
   * Prepare and store in joget a pending fleet request for database indicator
   * return a promise
   */
  async sendPendingFleetCountRequestToJoget(declaredDbData, row) {
    //Building data to send
    var moment = require("moment");
    var curentDateFormated = moment().format("YYYY-MM-DD HH:mm");
    var rowId = declaredDbData.indexOf(row);
    const declaredDbID = declaredDbData[rowId].id;
    if (
      declaredDbData[rowId].c_fleetCount != declaredDbData[rowId].oldFleetCount
    ) {
      var data = [
        { id: "requestDateTime", value: curentDateFormated },
        { id: "customerId", value: store.getters.getCurrentCustomer.id },
        {
          id: "contactId",
          value: store.getters.getCurrentUser.id
        },
        {
          id: "databaseIndicator",
          value: declaredDbData[rowId].c_databaseIndicator
        },
        {
          id: "originalFleetCount",
          value: declaredDbData[rowId].oldFleetCount
        },
        {
          id: "requestedFleetCount",
          value: declaredDbData[rowId].c_fleetCount
        },
        { id: "requestStatus", value: "pending" }
      ];
      var fleetCountUpdate = [
        { id: "fleetCount", value: declaredDbData[rowId].c_fleetCount },
      ];
      //Updating Fleet Count value 
      storeData(
        process.env.VUE_APP_DATABASES_APP_ID,
        process.env.VUE_APP_DECLARED_DATABASES_FORM,
        declaredDbID,
        fleetCountUpdate
      ).then(response => {
        if (!response.ok) {
          console.error("Error while sending Fleet Count modification request");
        }
      });

      //Making storing request
      storeData(
        process.env.VUE_APP_DATABASES_APP_ID,
        process.env.VUE_APP_DATABASES_FORM_PENDING_FLEET,
        "",
        data
      ).then(response => {
        if (response.ok) {
          //Updating local data if the request is succesfull
          alert("Fleet Count Modification Request has been sent for approval");
          if(store.isDownloadRequest && 
            store.dbIdentifier === declaredDbData[rowId].c_databaseIndicator &&
            store.dbType ===  declaredDbData[rowId].c_navdbType) {
              router.push("databases");
              store.isDownloadRequest = false;
          }
        } else {
          // eslint-disable-next-line no-console
          console.error("Error while sending Fleet Count modification request");
        }
      });
    }
  }

  /**
   * Update the data related to the customer in Vuex state
   */
  updateStoredCustomerData() {
    this.setCustomerRegions(this.formCustomerSettings.regions);
    this.setCustomerAccountManager(this.formCustomerSettings.accountManager);
    this.setCustomerContractID(this.formCustomerSettings.contractID);
    this.setCustomerContractType(this.formCustomerSettings.contractType);
    this.setCustomerContractStatus(this.formCustomerSettings.contractStatus);
    this.setCustomerContractStart(this.formCustomerSettings.contractStart);
    this.setCustomerContractEnd(this.formCustomerSettings.contractEnd);
    this.setCustomerDeliveryCycleStart(
      this.formCustomerSettings.deliveryCycleStart
    );
    this.setCustomerDeliveryCycleEnd(
      this.formCustomerSettings.deliveryCycleEnd
    );
  }
}
</script>
<style lang="scss">
.main-container {
  padding: 0 calc(1.5 * var(--spacer-default));
}

.profile-settings {
  margin-bottom: calc(1.5 * var(--spacer-default));
}
.change-password__actions {
  padding: calc(1.5 * var(--spacer-default)) 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .change-password__title {
    font-family: var(--font-default-regular-family);
    font-weight: 400;
    font-size: var(--font-size-h-3);
    color: var(--color-grey-1);
    opacity: 0.5;
  }
  .change-password__buttons {
    float: right;
    .nb-button {
      margin-left: var(--spacer-l);
    }
  }
}
.nb-input {
  width: 100%;
  display: inline-block;
}
.nb-tooltip {
  width: 150%;
}
.profile-settings__actions {
  @extend .change-password__actions;
  .profile-settings__title {
    @extend .change-password__title;
  }
  .profile-settings__buttons {
    @extend .change-password__buttons;
  }
}
.card-password {
  width: 100%;
  display: inline-block;
  margin-bottom: var(--spacer-default);
  .nb-card__body {
    padding: calc(1.5 * var(--spacer-default)) calc(1.5 * var(--spacer-default))
      calc(0.5 * var(--unit)) calc(1.5 * var(--spacer-default));
    .nb-form-item {
      padding-bottom: calc(0.5 * var(--spacer-default));
      width: 33%;
    }
  }
}
.card-settings {
  width: 100%;
  display: inline-block;
  margin-bottom: var(--spacer-default);
  .nb-card__body {
    padding: calc(1.5 * var(--spacer-default));
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .nb-avatar {
    margin-right: calc(2 * var(--spacer-default));
  }
  .card-settings-avatar__edit {
    margin: calc(3.8 * var(--spacer-default)) 0px 0px
      calc(-2.5 * var(--spacer-default));
    cursor: pointer;
  }
  .profile-settings__form {
    display: flex;
    flex-direction: column;
    .profile-settings__form__name {
      padding-bottom: calc(0.5 * var(--spacer-default));
    }
    .profile-settings__form__contract {
      padding-bottom: calc(0.5 * var(--spacer-default));
    }
    .profile-settings__form__email {
      margin-bottom: 0px;
    }
  }
  .databases-content {
    background-color: #ebebeb;
    padding: calc(var(--unit) * 2);
    .databases_title {
      margin-bottom: calc(var(--unit) * 2);
      font-size: var(--unit);
      color: var(--color-black4);
      display: flex;
      align-items: center;
      .nb-icon {
        margin-right: calc(var(--unit) * 0.75);
      }
    }
  }
}
</style>
